import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserManagementTabs } from './components/UserManagementTabs';
import { UsersTab } from './tabs/UsersTab';
import { TaskResponsibilitiesTab } from './tabs/TaskResponsibilitiesTab';
import './styles/user-management.css';

type TabType = 'users' | 'responsibilities';

const UserManagementTab: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabType>('users');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const handleTabChange = (newTab: TabType) => {
    if (hasUnsavedChanges && activeTab === 'responsibilities') {
      const confirmLeave = window.confirm(
        t(
          'admin.userManagement.responsibilities.confirmLeave',
          'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter cette page ? Vos modifications seront perdues.'
        )
      );

      if (!confirmLeave) {
        return;
      }

      // Reset unsaved changes state when leaving
      setHasUnsavedChanges(false);
    }

    setActiveTab(newTab);
  };

  return (
    <div className="user-management-page-container">
      {/* Page Header */}
      <div className="user-management-header">
        <div className="user-management-header-content">
          <div className="user-management-title-row">
            <div>
              <h1 className="user-management-title">
                {t('admin.userManagement.title', 'Gestion des Utilisateurs')}
              </h1>
              <p className="user-management-subtitle">
                {t('admin.userManagement.subtitle', 'Gérez les comptes utilisateurs et leurs permissions')}
              </p>
            </div>
            <div className="user-management-toggle-wrapper">
              <UserManagementTabs activeTab={activeTab} onTabChange={handleTabChange} />
            </div>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="user-management-content">
        <div className="user-management-content-inner">
          {activeTab === 'users' && <UsersTab />}
          {activeTab === 'responsibilities' && (
            <TaskResponsibilitiesTab onHasChangesChange={setHasUnsavedChanges} />
          )}
        </div>
      </div>
    </div>
  );
};

export { UserManagementTab };
export default UserManagementTab;